import {FacilityFilters} from "../../services/ngage/facilities";
import {useQuery} from "react-query";
import ngage from "../../services/ngage";

export default function useGetFacilities(
  criteria: FacilityFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['facilities', criteria],
    () => ngage.facilities.filtered(criteria),
    {enabled, keepPreviousData}
  );
}